import { FeatureFlag } from '../FeatureFlag';

export const useManagedOAuth = new FeatureFlag({
    key: 'use-managed-oauth',
    defaultValue: false,
});
